// GuestProfilesPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const GuestProfilesPage = () => <ComingSoon title="Guest profiles" description="Detailed guest profiles. Use Guest List for guest records for now." />;

export default GuestProfilesPage;
